var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.params.data)?_c('button',{staticClass:"viewGantt",on:{"click":function($event){return _vm.btnClickedHandler()}}},[_c('i',{class:_vm.params.iconClass}),_vm._v(" "+_vm._s(_vm.params.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }